module.exports = __webpack_public_path__ + "static/icon-8e6cdf3602ab693e6add8d379e02eda6.jpg";